import { h6Styles } from 'components/reusable-css';
import styled from 'styled-components';

export const Text = styled.h6`
  font-size: ${(props) => props.theme.default?.h6};
  ${(props) => h6Styles(props.theme.resolutions)};
`;
